module.exports = __webpack_public_path__ + "images/emoji/arrow_up_small.5f701dcbd331040991fe.png";